import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const StaticPageLayout = ({ overline, title, description, breadcrumbs = [], children }) => {
  return (
    <div className="bg-white" data-testid="static-page">
      {/* Breadcrumb */}
      <div className="bg-[#F5F7FA] border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center gap-1.5 text-sm text-[#6B7280] flex-wrap">
            <Link to="/" className="hover:text-[#1A73E8] transition-colors">Home</Link>
            {breadcrumbs.map((crumb, i) => (
              <React.Fragment key={crumb.label}>
                <ChevronRight size={12} className="text-[#D1D5DB]" />
                {i < breadcrumbs.length - 1 ? (
                  <Link to={crumb.path} className="hover:text-[#1A73E8] transition-colors">{crumb.label}</Link>
                ) : (
                  <span className="text-[#374151]">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Page header */}
      <div className="bg-[#F5F7FA] border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {overline && <p className="section-overline mb-3">{overline}</p>}
          <h1 className="font-serif text-4xl font-semibold text-[#1F1F1F] mb-3">{title}</h1>
          {description && <p className="text-[#6B7280] max-w-2xl text-sm leading-relaxed">{description}</p>}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-4xl">
          {children}
        </div>
      </div>
    </div>
  );
};

export default StaticPageLayout;
